import { api } from "./axios";

export type ClaimResponse = {
  claimed: boolean;
};

export const postClaim = async (
  fid: number,
  address: string
): Promise<ClaimResponse> => {
  const { data } = await api.post("/claim", { fid, address });
  return data;
};

export const getClaimStatus = async (fid: number): Promise<ClaimResponse> => {
  const { data } = await api.get(`/claim/${fid}`);
  return data;
};
